import ReactDOM from 'react-dom/client';
import React from 'react';
import Base from './Base.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <Base />
  </React.StrictMode>

);
